import React from 'react'

import MenuItem, { MenuItemType } from 'src/chrome/HelpMenu/MenuItem'
import { useSelector, useState } from 'src/hooks'
import styles from './helpmenu.module.scss'
import { Icon } from 'src/design_system/atoms/icons/components/Icon'

const HelpMenu: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { tourId } = useSelector(state => state.helpmenu)
  const [isIntercomOpen, setIsIntercomOpen] = useState(false)
  const [isIntercomOnHideSetup, setIsIntercomOnHideSetup] = useState(false)

  const toggleMenu = () => {
    setIsOpen(open => !open)
    handleIntercom(false)
  }

  const setupIntercomOnHide = () => {
    if (!isIntercomOnHideSetup) {
      window.Intercom('onHide', () => {
        handleIntercom(false)
      })
      setIsIntercomOnHideSetup(true)
    }
  }

  const handleIntercom = (shouldOpen: boolean) => {
    if (shouldOpen) {
      if (window.Intercom) {
        setupIntercomOnHide()
        window.Intercom('show')
        setIsIntercomOpen(shouldOpen)
      } else {
        console.log(
          'Intercom does not exist on the window, please check your intercom config script',
        )
      }
    } else {
      window.Intercom('hide')
      setIsIntercomOpen(shouldOpen)
    }
  }

  const launchTips = () => {
    window.Appcues.show(tourId)
  }

  const items: MenuItemType[] = [
    {
      title: 'Terms',
      icon: {
        icon: 'LIST',
        color: '#333',
        size: 16,
        viewBox: '0 0 1024 1154',
      },
      link: 'https://help.sendoutcards.com/sendoutcards/en/articles/432937-what-are-the-sendoutcards-policies-and-procedures',
    },
    {
      title: 'Privacy',
      icon: {
        icon: 'COG',
        color: '#333',
        size: 17,
        viewBox: '0 0 1024 1154',
      },
      link: 'https://www.sendoutcards.com/resources/privacy-policy/',
    },
    {
      title: 'Help',
      icon: {
        icon: 'LIST',
        color: '#333',
        size: 16,
      },
      link: 'https://help.sendoutcards.com',
    },
    {
      title: 'Message',
      onClick: () => handleIntercom(!isIntercomOpen),
      icon: {
        icon: 'CHAT',
        color: '#333',
        size: 18,
        viewBox: '0 0 1024 1154',
      },
    },
    {
      title: 'Tips',
      onClick: launchTips,
      disabled: !tourId,
      icon: {
        icon: 'INFO',
        color: '#333',
        size: 18,
      },
    },
  ]
  return (
    <div className={styles.floatingMenu}>
      <div
        className={
          isOpen ? `${styles.helpMenu} ${styles.open}` : styles.helpMenu
        }
      >
        <div className={styles.menuItems}>
          {items.map((item: MenuItemType, index: number) => {
            return item.disabled ? null : <MenuItem key={index} item={item} />
          })}
        </div>
        <div className={styles.floatingMenuAction}>
          <div className={styles.mainButton} onClick={toggleMenu}>
            <Icon
              size={isOpen ? 12 : 18}
              color="#fff"
              name={isOpen ? 'cancel' : 'question_mark'}
            />
            <p
              style={{
                fontFamily: 'Montserrat, sans-serif',
                lineHeight: '1.2rem',
                fontSize: '13px',
              }}
            >
              {isOpen ? 'Close' : 'Help'}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HelpMenu
